import { useLatest } from "../";
import { useCompareEffect } from "../";

import type { BasicTarget } from "./helpers";
import { getTargetElement, useStableTarget } from "./helpers";

export type ResizeObserverTarget = BasicTarget<HTMLElement | Element>;

export function useResizeObserver(
  handler: (entries: ResizeObserverEntry[], observer: ResizeObserver) => void,
  element?: ResizeObserverTarget,
  options?: ResizeObserverOptions
): void {
  const savedHandler = useLatest(handler);
  const { key: elementKey, ref: elementRef } = useStableTarget(element);

  useCompareEffect(() => {
    const targetElement = getTargetElement(elementRef.current);
    if (!targetElement || typeof ResizeObserver === "undefined") {
      return;
    }

    const resizeObserver = new ResizeObserver((entries, observer) => {
      savedHandler.current(entries, observer);
    });

    resizeObserver.observe(targetElement, options);

    return () => {
      resizeObserver.disconnect();
    };
  }, [elementKey, options]);
}
